import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    signers: [],
};

const signerSlice = createSlice({
    name: "signers",
    initialState,
    reducers: {
        setSigners(state, action) {
            state.signers = action.payload; 
        },
        addSigner(state, action) {
            state.signers.push(action.payload); 
        },
        removeSigner(state, action) {
            const idsToRemove = Array.isArray(action.payload)
              ? action.payload
              : [action.payload];
          
            state.signers = state.signers.filter(signer => !idsToRemove.includes(signer.id));
        },
        updateSignerEsignType(state, action) {
            const updates = Array.isArray(action.payload)
              ? action.payload
              : [action.payload];
          
            updates.forEach(update => {
              const signer = state.signers.find(s => s.id === update.id);
              if (signer) {
                signer.esign_type_new = update.esign_type;
              }
            });
        }
    },
});

export const { setSigners, addSigner, removeSigner, updateSignerEsignType } = signerSlice.actions;
export default signerSlice.reducer;
